import React, { useEffect, useState } from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
} from 'recharts'
import Grid from '@material-ui/core/Grid'
import { Moment } from 'moment'

import { useApiCall } from 'hooks'
import { snackbar } from 'components'
import { ERRORS } from 'consts'

import { getInvoicesbyTags } from '../api'
import { ParametersDownload } from '../types'

interface Props {
  startDate: Moment
  endDate: Moment
}

const TagsByInvoices: React.FC<Props> = ({ startDate, endDate }) => {
  const [data, setData] = useState<{ name: string, value: number, percent: number }[]>([])

  // ✅ Usamos la función sin pasarle argumentos directamente
  const [requestInvoicesTags] = useApiCall<ParametersDownload, any>(getInvoicesbyTags)

  useEffect(() => {
    requestInvoicesTags({ startDate, endDate })
      .then(resp => {
        const rawData = resp.data || []
        const total = rawData.reduce((acc: number, item: any) => acc + item.invoiceCount, 0)

        const preparedData = rawData.map((item: any) => ({
          name: item.tagName,
          value: item.invoiceCount,
          percent: total ? item.invoiceCount / total : 0,
        }))

        setData(preparedData)
      })
      .catch(() => {
        snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE)
        setData([])
      })
  }, [startDate, endDate, requestInvoicesTags]) // ✅ `requestInvoicesTags` ya no está en las dependencias

  const renderCustomizedLabel = (props: any) => {
    const { x, y, width, value, height } = props
    return (
      <text
        x={x + width / 2}
        y={y - 20 + height / 2}
        fill="black"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {`(${(value * 100).toFixed(0)}%)`}
      </text>
    )
  }

  return (
    <Grid
      container
      spacing={2}
      style={{
        background: '#fff',
        boxShadow: '0 2px 7px 0 rgba(0,0,0,.06)',
      }}
    >
      <Grid item xs={12}>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 5, right: 50, left: 20, bottom: 5 }} barSize={60}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Bar dataKey="value" fill="#e78923">
              <LabelList dataKey="percent" content={renderCustomizedLabel} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Grid>
    </Grid>
  )
}

export { TagsByInvoices }
